import { memo } from 'react'
import isEqual from 'react-fast-compare'
import styled from 'styled-components'

import { decodeHtml } from '@nx/decode-html'
import { Label } from '@nx/fire/typography'
import { buildPriceString } from '@nx/helpers'
import { getTranslate } from '@nx/translations'

import translate from './StartingBid.translate.json'

const { text } = getTranslate(translate)

export const StartingBid = memo(
  ({ currencySymbol, price, ...props }: StartingBidProps) => (
    <StyledStartingBidLabel $level="M" {...props}>
      {text('starting', {
        price: buildPriceString({
          currencySymbol: decodeHtml(currencySymbol),
          lowPrice: price,
        }),
      })}
    </StyledStartingBidLabel>
  ),
  isEqual
)

export const StyledStartingBidLabel = styled(Label)`
  /* Empty for override styles */
`

export interface StartingBidProps {
  currencySymbol: string
  price: number
}
